import { coreOnboardingProgressGetAsyncSlice } from './get';
import { coreOnboardingProgressName } from './name';
import { createUpdateSyncSlice } from '@sonar-software/xuder';
import { GetOnboardingProgressResponse } from '@api';

const defaultState: GetOnboardingProgressResponse = {
	currentlyRunningSfdcImportId: 0,
	isSalesforceConnected: false,
	isSalesforceSynced: false,
	latestSuccessfulSfdcImportId: 0
};

export const coreOnboardingProgressUpdateSyncSlice = createUpdateSyncSlice({
	name: coreOnboardingProgressName,
	state: coreOnboardingProgressGetAsyncSlice.asyncState,
	transform: (action: Partial<GetOnboardingProgressResponse>, state = defaultState) => ({
		...state,
		...action
	})
});
